import { AuctionsState } from './auctions.interfaces';

export const defaultAuctionsState: AuctionsState = {
    auctions: [],
    isCreatingAuction: false,
    isLoaded: false,
    isLoading: false,
};
